import { useMemo, useRef, useState } from 'react'
import { getStoredEnglishTestEmail } from './testStorage'
import type { EnglishTestAnswerReview, EnglishTestModalProps, QuestionAnswerValue } from './types'
import {
  ENGLISH_TEST_GROUP_SIZE,
  byDisplayOrder,
  hasAnsweredQuestion
} from './questionUtils'

type UseEnglishTestModalStateArgs = Pick<EnglishTestModalProps, 'defaultTest'>

export function useEnglishTestModalState({ defaultTest }: UseEnglishTestModalStateArgs) {
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0)
  const [answers, setAnswers] = useState<QuestionAnswerValue[]>([])
  const [submittedAnswers, setSubmittedAnswers] = useState<Record<number, EnglishTestAnswerReview>>(
    {}
  )
  const [submissionError, setSubmissionError] = useState<string | null>(null)
  const questionsContainerRef = useRef<HTMLDivElement | null>(null)
  const submittedTextAnswersRef = useRef<Record<number, string>>({})
  const storedEmailValue = getStoredEnglishTestEmail()

  const questions = useMemo(
    () => [...(defaultTest?.questions ?? [])].sort(byDisplayOrder),
    [defaultTest]
  )
  const totalQuestions = questions.length
  const totalGroups = totalQuestions > 0 ? Math.ceil(totalQuestions / ENGLISH_TEST_GROUP_SIZE) : 1
  const groupStartIndex = currentGroupIndex * ENGLISH_TEST_GROUP_SIZE
  const visibleQuestions = questions.slice(groupStartIndex, groupStartIndex + ENGLISH_TEST_GROUP_SIZE)
  const answeredCount = answers.filter(hasAnsweredQuestion).length
  const progressPercent = totalQuestions > 0 ? (answeredCount / totalQuestions) * 100 : 0
  const isLastGroup = currentGroupIndex === totalGroups - 1

  return {
    answers,
    answeredCount,
    currentGroupIndex,
    groupStartIndex,
    isLastGroup,
    progressPercent,
    questions,
    questionsContainerRef,
    setAnswers,
    setCurrentGroupIndex,
    setSubmissionError,
    setSubmittedAnswers,
    storedEmailValue,
    submissionError,
    submittedAnswers,
    submittedTextAnswersRef,
    totalGroups,
    totalQuestions,
    visibleQuestions
  }
}
